import React from 'react';

interface Props {
   sample: string;
}

const Developers = () => {
   return <div>Developers</div>;
};

export default Developers;
